import React, { use, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import allTeams from "../../data/teams";
import { Chart as ChartJS } from "chart.js/auto"; // Tout est déjà enregistré
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

const tableStyling = {
  padding: "4px 8px",
  lineHeight: "1.75rem",
  textAlign: "center" as const,
  fontSize: "12px",
  height: "38px",
};

const bigCell = {
  width: "130px",
  textAlign: "left" as const,
};

const CellMobile = {
  width: "130px",
  "@media (max-width: 600px)": {
    width: "40px",
  },
  textAlign: "left" as const,
  span: {
    display: "inline",
    "@media (max-width: 600px)": {
      display: "none",
    },
  },
};

const headerTable = {
  backgroundColor: "#f5f5f5",
  borderBottom: "2px solid #e0e0e0",
  FontWeight: "900",
};

const Skaters = ({ skaterData, type }) => {
  // const [skaterStats, setSkaterStats] = useState(skater);
  const safeSkaterData = Array.isArray(skaterData) ? skaterData : [];

  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ ...headerTable }}>
            <TableRow>
              <TableCell sx={{ ...tableStyling }}>Rank</TableCell>
              <TableCell sx={{ ...tableStyling, ...bigCell }}>Name</TableCell>
              <TableCell sx={{ ...tableStyling }}>#</TableCell>
              <TableCell sx={{ ...tableStyling }}>Position</TableCell>
              <TableCell sx={{ ...tableStyling, ...CellMobile }}>
                team
              </TableCell>
              <TableCell sx={{ ...tableStyling }}>{type}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {safeSkaterData.map((skater, index) => (
              <TableRow key={index}>
                <TableCell sx={{ ...tableStyling }}>{index + 1}</TableCell>
                <TableCell sx={{ ...tableStyling, ...bigCell }}>
                  <Link to={`/player/${skater.id}`}>
                    {skater.firstName.default} {skater.lastName.default}
                  </Link>
                </TableCell>
                <TableCell sx={{ ...tableStyling }}>
                  {skater.sweaterNumber}
                </TableCell>
                <TableCell sx={{ ...tableStyling }}>
                  {skater.position}
                </TableCell>
                <TableCell sx={{ ...tableStyling, ...CellMobile }}>
                  <Link to={`/team/${skater.teamAbbrev}`}>
                    <img width={35} src={skater.teamLogo} />
                    <span>{skater.teamName.default}</span>
                  </Link>
                </TableCell>
                <TableCell sx={{ ...tableStyling }}>
                  {skater.position === "G"
                    ? Number(skater.value).toFixed(3)
                    : skater.value}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Skaters;
